// Icônes du site public, en SVG en ligne (trait, couleur héritée du texte).
import React from "react";

const Svg = ({ taille = 18, children, epaisseur = 2, ...reste }) => (
	<svg
		width={taille}
		height={taille}
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth={epaisseur}
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		focusable="false"
		{...reste}
	>
		{children}
	</svg>
);

export const IconeCoche = (p) => (
	<Svg {...p}>
		<circle cx="12" cy="12" r="9" />
		<path d="m8.5 12.2 2.4 2.4 4.7-4.9" />
	</Svg>
);

export const IconeEtoile = ({ taille = 16 }) => (
	<svg width={taille} height={taille} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
		<path d="M12 2.8 14.8 8.6l6.3.8-4.6 4.4 1.2 6.3L12 17l-5.7 3.1 1.2-6.3L2.9 9.4l6.3-.8z" />
	</svg>
);

export const IconeHaltere = (p) => (
	<Svg {...p}>
		<path d="M6 7v10M18 7v10M3 10v4M21 10v4M6 12h12" />
	</Svg>
);

export const IconePlanche = (p) => (
	<Svg {...p}>
		<rect x="5" y="4" width="14" height="17" rx="2" />
		<path d="M9 4h6v3H9zM9 12h6M9 16h4" />
	</Svg>
);

export const IconeMenu = (p) => (
	<Svg {...p}>
		<path d="M4 7h16M4 12h16M4 17h16" />
	</Svg>
);

export const IconeFermer = (p) => (
	<Svg {...p}>
		<path d="M6 6l12 12M18 6 6 18" />
	</Svg>
);

export const IconePlus = (p) => (
	<Svg {...p}>
		<path d="M12 5v14M5 12h14" />
	</Svg>
);

export const IconeFleche = (p) => (
	<Svg {...p}>
		<path d="M5 12h14M13 6l6 6-6 6" />
	</Svg>
);
